<template>
    <div class="modal fade" id="importImplantConfirmModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" id="exampleModalLabel">Δήλωση εισαγωγής μοσχεύματος</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <p>Εισαγωγή του μοσχεύματος;</p>
                </div>
                <div class="modal-footer">
                    
                    <button type="button" class="btn" data-bs-dismiss="modal" @click="cancelModal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                    <button type="submit" class="btn" @click="handleSubmit"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Υποβολή</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="importImplantModal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" id="exampleModalLabel">Δήλωση εισαγωγής μοσχεύματος</h6>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div>
                        <div class="row mb-2">
            <div class="col-2 mt-2">
                <label for="category" class="form-label">Κατηγορία:</label>
            </div>
            <div class="col-10">
                <select id="category" name="category" class="form-control" v-model="selectedCategoryId"
                    placeholder="Επιλέξτε ίδρυμα ιστών">
                    <option value="" selected>Επιλέξτε Κατηγορία</option>
                    <option v-for="category in categories" :key="category.id" :value="category.id">{{
                        category.category }}</option>
                </select>             
            </div>
        </div>   

        <div class="row mb-2">
            <div class="col-2 mt-2">
                <label class="form-label">Μόσχευμα:</label>
            </div>
            <div class="col-10">
                <select id="implant" name="implant" class="form-control" v-model="selectedImplantId"
                    placeholder="Μόσχευμα">
                    <option value="" selected style="color:#404040">Διαθέσιμα μοσχεύματα βάση χρήστη...</option>
                    <option v-for="implant in implants" :key="implant.id" :value="implant.id">{{
                        implant.implant }}</option>
                </select>         
            </div>
        </div>   


        <div class="row mb-2">
            <div class="col-2 mt-2">
                <label class="form-label">Προμηθευτής:</label>
            </div>
            <div class="col-8">
                <select id="provider" name="provider" class="form-control" v-model="selectedProviderId"
                    placeholder="Προμηθευτής">
                    <option value="" selected>Διαθέσιμοι προμηθευτές βάση χρήστη...</option>
                    <option v-for="provider in providers" :key="provider.id" :value="provider.id">{{
                        provider.title }}</option>
                </select>            
            </div>
           
            <div class="col-2">
                <input type="text" readonly :value="providerOrigin" class="form-control" />
            </div>
        </div>
                   
        <div class="row mb-2">
            <div class="col-2 mt-2">
                <label class="form-label">Παραλαβή:</label>
            </div>
            <div class="col-4">
                <input type="text" v-model="receiveDate" class="form-control fp fp-main" placeholder="ηη/μμ/εεεε" />
            </div>
           
            <div class="col-2">
            </div>
        </div>
                       
                       
        <div class="d-flex justify-content-start mb-2" :class="{ 'disabled': disabledFile }">
            <div>
                <h5>Στοιχεία Εκτελωνισμού (Έγγραφο Διασάφησης)</h5>
            </div>
        </div>
        
        <div :class="{ 'disabled': disabledFile }" class="p-2 mb-1">
            <div class="row mb-3" >
            <div class="col-3 mt-2">
                <label class="form-label">Αρ. Πρωτοκόλλου:</label>
            </div>
            <div class="col-3">
                                <input type="text" v-model="protoNum" class="form-control" :disabled="disabledFile" />
            </div>
            <div class="col-2 mt-2">
                <label for="zip" class="form-label">Ημνία:</label>
            </div>
            <div class="col-4">
                <input type="text" v-model="protoDate" class="form-control fp fp-proto"  placeholder="ηη/μμ/εεεε" :disabled="disabledFile" />
            </div>
        </div>
                          


        <div class="row mb-2">
            <div class="col-2 mt-2">
                <label class="form-label">Επισύναψη:</label>
            </div>
            <div class="col-10">
                <input type="file" class="form-control" @change="handleFileUpload"
                                    :disabled="disabledFile" />     
                <div v-if="existingFileName && !disabledFile" class="mt-2">
                    <small class="me-2">Υπάρχον αρχείο: {{ existingFileName }}</small>
                    <button type="button" class="btn btn-sm" @click="downloadExistingFile">Προβολή PDF</button>
                </div>
                </div>
            </div>   
        </div>
        <div class="row mb-2">
            <div class="col-2 mt-2">
                <label class="form-label">Κωδικός SEC:</label>
            </div>
            <div class="col-10">
               <input type="text" :value="sec" class="form-control" maxlength="40" required
                @keydown.space.prevent="rejectSecSpaces"
                @paste="onSecPaste"
                @input="onSecInput" />
            </div>
        </div>   
                     

        <div class="row mb-2" >
            <div class="col-3 mt-3">
                <label class="form-label">Απόδοση SEC:</label>
            </div>
            <div class="col-3 mt-2">
                <select class="form-control" v-model="secOption">
                    <option value=""></option>
                    <option value="1">Αποδόθηκε</option>
                    <option value="2">Προϋπήρχε</option>
                </select>            
            </div>
            <div class="col-3" :class="{ 'disabled': secOption != '1' }" style="padding-top:5px">
                <label class="form-label">Κωδ. Προϊόντος Προμηθευτή:</label>
            </div>
            <div class="col-3" :class="{ 'disabled': secOption != '1' }" style="padding-top:5px">
                <input type="text" v-model="providerProductCode" class="form-control"
                :disabled="secOption != '1'" />            
            </div>
        </div>
                        
        
        
        <div class="row" >
            <div class="col-3">
                <label class="form-label">Ημ/νία Λήξης Μοσχεύματος:</label>
            </div>
            <div class="col-3">
                <input type="text" v-model="expirationDate" class="form-control fp fp-main"  placeholder="ηη/μμ/εεεε" :min="receiveDate" />
            </div>
            <div class="col-6" v-if="!isEdit">
                <div class="d-flex justify-content-start">
                <input type="checkbox" v-model="tmpSave" />
                <label class="form-label ms-2 mt-2">Προσωρινή αποθήκευση</label>
                </div>
            </div>
        </div>
    </div>
            </div>
                <div class="modal-footer">
                    
                    <button type="button" class="btn" data-bs-dismiss="modal"><img src="../assets/images/close16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Άκυρο</button>
                    <button type="submit" class="btn" @click="confirmModal"><img src="../assets/images/save16.png" alt="Citrine Logo" class="menu-img" style="width:1.1em; margin-right:10px">Υποβολή</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import { getGraftCategories, getImplantsForInstitute, importImplantStatement } from "@/services/grafts";
import { downloadFile, fetchUserInfo } from "@/services/institutions";
import { getLocationPerProvider, getProviderOrigin, getProvidersForInstitute } from "@/services/provider";
import { useToast } from "vue-toastification";
import flatpickr from 'flatpickr'

export default {
    props: {
        isEdit: {
            type: Boolean,
            default: false
        },
        initialData: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isInitializing: false,
            disabledFile: true,
            tmpSave: false,
            expirationDate: "",
            providerProductCode: "",
            sec: "",
            secOption: "",
            file: null,
            protoDate: "",
            protoNum: "",
            receiveDate: "",
            providerOrigin: "-",
            selectedProviderId: "",
            selectedCategoryId: "",
            selectedImplantId: "",
            categories: [],
            implants: [],
            providers: [],
            fpInstances: [],
            lastLoadedCategoryId: null,
            existingFileName: "",
            existingMimeType: ""

        };
    },
    methods: {
        async loadImplantsByCategory(catid) {
            const normalizedCatId = catid ? Number(catid) : null;
            if (!normalizedCatId) {
                this.implants = [];
                this.lastLoadedCategoryId = null;
                return;
            }
            if (this.lastLoadedCategoryId === normalizedCatId) {
                return;
            }

            this.lastLoadedCategoryId = normalizedCatId;
            const userInfo = await fetchUserInfo();
            const r = await getImplantsForInstitute({
                instid: userInfo.data.institution.id,
                catid: normalizedCatId
            });
            if (r.data.success) {
                this.implants = r.data.data;
            }
        },
        async loadProviders() {
            const userInfo = await fetchUserInfo();
            const r = await getProvidersForInstitute({ instid: userInfo.data.institution.id });
            if (r.data.success) {
                this.providers = r.data.data;
            }
        },
        async openModal() {
            if (this.isInitializing) return;
            this.isInitializing = true;

            this.resetForm();
            const categoriesResponse = await getGraftCategories();
            if (categoriesResponse.data.success) {
                this.categories = categoriesResponse.data.data;
            }

            if (this.initialData) {
                await this.loadImplantsByCategory(this.initialData.catid);
                await this.loadProviders();
                this.applyInitialData(this.initialData);
            } else {
                await this.loadProviders();
            }

            this.$nextTick(() => {
                $("#importImplantModal").modal("show");

                this.destroyFlatpickr?.();

                this.fpInstances = flatpickr('.fp', {
                altFormat: "d-m-Y",
                dateFormat: 'Y-m-d',
                allowInput: true,
                altInput: true,
                });

                this.isInitializing = false;
            });
        },
        stripSec(value) {
            return String(value ?? '').replace(/\s/g, '');
        },
        rejectSecSpaces() {
            const now = Date.now();
            if (now - (this._secSpaceToastAt || 0) < 1600) return;
            this._secSpaceToastAt = now;
            useToast().error('Ο κωδικός SEC δεν επιτρέπεται να περιέχει κενά.');
        },
        onSecInput(event) {
            const raw = event.target.value;
            const cleaned = this.stripSec(raw).slice(0, 40);
            if (/\s/.test(raw)) this.rejectSecSpaces();
            this.sec = cleaned;
            if (event.target.value !== cleaned) event.target.value = cleaned;
        },
        onSecPaste(event) {
            const text = event.clipboardData?.getData('text') ?? '';
            if (!/\s/.test(text)) return;
            event.preventDefault();
            const input = event.target;
            const start = input.selectionStart ?? String(this.sec).length;
            const end = input.selectionEnd ?? start;
            const merged = String(this.sec).slice(0, start) + text + String(this.sec).slice(end);
            this.sec = this.stripSec(merged).slice(0, 40);
            // this.rejectSecSpaces();
        },
        applyInitialData(val) {
            this.selectedCategoryId = val.catid ? Number(val.catid) : "";
            this.selectedImplantId = val.implant_id ? Number(val.implant_id) : "";
            this.selectedProviderId = val.provider_id ? Number(val.provider_id) : "";

            this.receiveDate = val.inst_recvdate || "";
            this.expirationDate = val.exp_date || "";
            this.protoDate = val.proto_date || "";
            this.protoNum = val.proto_num || "";

            this.sec = val.sec || "";
            this.secOption = val.inst_impl_code ? "1" : "2";
            this.providerProductCode = val.inst_impl_code || "";
            this.existingFileName = val.file_name || "";
            this.existingMimeType = val.mime_type || "";
        },
       isValidDate(date) {
    if (!(date instanceof Date) || isNaN(date.getTime())) {
        return false;
    }

    

    // MySQL valid date range check
    const minDate = new Date('1000-01-01');
    const maxDate = new Date('9999-12-31');

    return date >= minDate && date <= maxDate;
},

        async handleFileUpload(event) {
            const file = event.target.files[0]; // Get the selected file
            if (file) {
                this.file = file;

                // Optionally, preview or process the file
                const reader = new FileReader();
                reader.onload = (e) => {
                    console.log("File content preview:", e.target.result);
                    // Perform further actions like uploading to the server
                };
                reader.readAsDataURL(file);
            }
        },
        downloadExistingFile() {
            if (!this.initialData?.id || !this.existingFileName) return;
            downloadFile(this.initialData.id, this.existingFileName, this.existingMimeType);
        },
         resetForm() {
            this.sec = '';
            this.disabledFile = '';
            this.selectedCategoryId = '';
            this.selectedImplantId = '';
            this.instId = '';
            this.receiveDate = '';
            this.expirationDate = '';
            this.providerProductCode = '';
            this.file = null;
            this.protoDate = '';
            this.protoNum = '';
            this.providerOrigin = '';
            this.selectedProviderId = '';
            this.selectedCategoryId = '';
            this.selectedImplantId = '';
            this.secOption = '';
            this.lastLoadedCategoryId = null;
            this.existingFileName = '';
            this.existingMimeType = '';
        },
        confirmModal() {
            if (this.tmpSave) {
                this.handleSubmit();
                $("#importImplantModal").modal('hide');
                this.resetForm();
                this.$emit("close");
                return;
            }


            if (this.selectedCategoryId == null || this.selectedCategoryId == '') {
                useToast().error('Το πεδίο κατηγορία είναι απαραίτητο.');
                return;                
            }
            if (this.selectedImplantId == null || this.selectedImplantId == '') {
                useToast().error('Το πεδίο μόσχευμα είναι απαραίτητο.');
                return;                
            }
            if (this.selectedProviderId == null || this.selectedProviderId == '') {
                useToast().error('Το πεδίο προμηθευτής είναι απαραίτητο.');
                return;                
            }
           
            const date = new Date();
            const receiveDateObj = new Date(this.receiveDate);
            if (!this.isValidDate(receiveDateObj)) {
                useToast().error('Παρακαλώ εισάγετε μια έγκυρη ημερομηνία παραλαβής');
                return;
            };
            if (receiveDateObj > date) {
                useToast().error('Η ημερομηνία παραλαβής δεν μπορεί να είναι μεταγενέστερη της σημερινής.');
                return;
            }
            if (this.sec.length != 40) {
                useToast().error('Το μέγεθος του κωδικού πρέπει να είναι 40 χαρακτήρες. Εισάγετε τον σωστό κωδικό και προσπαθήστε ξανά.');
                return;
            }
            if (this.secOption == '' || this.secOption == null) {
                useToast().error('Το πεδίο απόδοση sec είναι απαραίτητο.');
                return;            
            }
           
        
            
        const expirationDateObj = new Date(this.expirationDate);

        if (!this.isValidDate(expirationDateObj)) {
            useToast().error('Έχετε εισάγει λανθασμένη ημερομηνία λήξης.');
            return;
        };

        if (this.expirationDate == null || this.expirationDate == '') {
                        useToast().error('Το πεδίο ημερομηνία λήξης είναι απαραίτητο.');
                        return;                
                    }

        const protoDateObj = new Date(this.protoDate);

        if (this.protoDate != ''){
        if (!this.isValidDate(protoDateObj)) {
            useToast().error('Έχετε εισάγει λανθασμένη ημερομηνία εκτελωνισμού.');
            return;
        };
        }

        if (expirationDateObj < receiveDateObj) {
            useToast().error('H ημερομηνία λήξης δεν μπορεί να είναι προγενέστερη της ημερομηνίας παραλαβής.');
            return;
        };

            if (!this.disabledFile) {
                if (this.protoDate != '' && this.receiveDate != '') {
                    const d1 = new Date(this.protoDate);
                    const d2 = new Date(this.receiveDate);
                    if (d1 > d2) {
                        useToast().error('Η ημ/νία εκτελωνισμού δεν πρέπει να είναι μεταγενέστερη της ημ/νίας παραλαβής.');
                        return;
                    }
                }
            }
            if (!this.disabledFile) {
                if (this.protoNum == '') {
                    useToast().error('Το πεδίο αριθμός πρωτοκόλλου εκτελωνισμού είναι απαραίτητο.');
                    return;
                }
                if (this.protoDate == '') {
                    useToast().error('Δεν έχετε εισάγει ημ/νία εκτελωνισμού.');
                    return;
                }
                if (this.file == null && !this.existingFileName) {
                    useToast().error('Δεν έχετε εισάγει έγγραφο διασάφησης. Επιλέξτε έγγραφο και προσπαθήστε ξανά.');
                    return;
                }
            }
            if (this.secOption == '1') {
                if (this.providerProductCode == '') {
                    useToast().error('Δεν έχετε εισάγει κωδικό προϊόντος προμηθευτή. Εισάγετε τον κωδικό και προσπαθήστε ξανά.');
                    return;
                }
            }
            if (this.tmpSave) {
                this.handleSubmit(); 
                $("#importImplantModal").modal('hide');
            } else {
                $("#importImplantConfirmModal").modal('show');
                $("#importImplantModal").modal('hide');
            }

        },
        cancelModal() {
            $("#importImplantConfirmModal").modal('hide');
            $("#importImplantModal").modal('hide');

            this.resetForm();
            this.fpInstances = [];

            this.$emit("close");
        },
        async handleSubmit() {
            const formData = new FormData();
            formData.append("implant_id", this.selectedImplantId);
            formData.append("provider_id", this.selectedProviderId);
            formData.append("inst_recvdate", this.receiveDate);
            if (!this.disabledFile) {
                formData.append("proto_num", this.protoNum);
                formData.append("proto_date", this.protoDate);
                if (this.file) {
                    formData.append("file", this.file);
                }
            }
            if (this.secOption == '1') {
                formData.append("inst_impl_code", this.providerProductCode);
            }
            formData.append("sec", this.sec);
            formData.append("exp_date", this.expirationDate);
            formData.append("istemp_inst", this.tmpSave ? '1' : '0');
            formData.append("status", "1");
            formData.append("apply_hospital_id", "0");
            formData.append("apply_status", "0");
            formData.append("id", this.initialData?.id || 0);
            const userInfo = await fetchUserInfo();
            formData.append("institude_id", userInfo.data.institution.id);

            const response = await importImplantStatement(formData);
            if (response.data.success) {
                $("#importImplantConfirmModal").modal('hide');
                useToast().success(response.data.message);
                this.resetForm(); 
                const categoriesResponse = await getGraftCategories();
            if (categoriesResponse.data.success) {
                this.categories = categoriesResponse.data.data;
            }
            this.$emit("saved");
            this.$emit("close");

            } else {
                useToast().error(response.data.message);
            }
        }
    },
    async mounted() {
        this.openModal();
    },
    unmounted() {
        // no-op
    },
    watch: {

        initialData: {
            handler(val) {
            if (!val || this.isInitializing) return;
            this.applyInitialData(val);
            }
        },
        
        selectedCategoryId: {
            async handler(val) {
                if (this.isInitializing || !val) return;
                await this.loadImplantsByCategory(val);
            }
        },
        selectedImplantId: {
            immediate: true,
            handler() {}
        },
        selectedProviderId: {
            immediate: true,
            async handler(newValue) {
                if (!newValue) {
                    // No provider selected, keep it disabled
                    this.disabledFile = true;
                    return;
                }

                const r1 = await getLocationPerProvider({ id: newValue });
                if (r1.data?.data?.location !== 'EU') {
                    this.disabledFile = false;
                } else {
                    this.disabledFile = true;
                }
                const r2 = await getProviderOrigin({ provid: newValue });
                if (r2.data.success) {
                    this.providerOrigin = r2.data.data.origin;
                }
            }

        

    },

        disabledFile(newVal) {
        if (!this.fpInstances) return;

        this.fpInstances.forEach(fp => {
        if (!fp.input.classList.contains('fp-proto')) return;

        if (newVal) {
            fp.altInput.setAttribute("disabled", true);
            fp.input.setAttribute("disabled", true);
        } else {
            fp.altInput.removeAttribute("disabled");
            fp.input.removeAttribute("disabled");
        }
    });
}
            }
};
</script>

<style scoped>
.nav-tabs {
    border-bottom: 1px solid #ddd;
}

.nav-link {
    cursor: pointer;
}

.table {
    margin-top: 1rem;
    width: 100%;
}

.btn {
    background-color: #f6f6f6;
}

.btn:hover,
.btn-md:hover {
    background-color: #ececec;
}

.btn-md {
    background-color: white;
    border: none;
}

.page-container {
    display: flex;
    width: 100%;
    height: 100%;
    /* Ensures the layout fits the screen height */
    overflow: hidden;
    /* Prevent overflow when zoomed */
}

.content-area {
    flex: 1;
    /* Default flex value */
    transition: all 0.3s ease-in-out;
    min-width: 0;
    /* Prevent the content from overflowing */
    padding-right: 10px;
    /* Add slight padding to avoid overlap */
}

.content-area.shrink {
    flex: 0.68;
    /* Slightly smaller to provide more space for details */
}

.implant_details {
    flex: 0.32;
    /* Adjusted to match shrink */
    overflow-y: auto;
    transition: all 0.3s ease-in-out;
    padding-left: 10px;
    border-left: 1px solid rgb(94, 94, 94);
    margin-left: 10px;
    min-width: 280px;
    /* Ensure the details panel doesn't shrink too much */
}

.implant-details-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
}

.implant-detail {
    background: #fff;
    border-radius: 15px;
    box-shadow: 3px 3px 15px #c2c2c2;
    padding: 8px;
    width: calc(100% - 20px);
    /* Default to full width */
    padding-left: 10px;
    font-size: medium;
}

.label-text {
    font-size: 0.9rem;
    color: #6c757d;
    /* Muted text for the label */
    margin-bottom: 5px;
    display: block;
    /* Ensure label appears above */
}

.value-text {
    font-size: 1rem;
    font-weight: bold;
    color: #000;
}

.table {
    width: 100%;
    /* Ensure table stays within bounds */
    table-layout: fixed;
    /* Prevent columns from expanding uncontrollably */
    word-wrap: break-word;
    /* Handle long text gracefully */
}

th,
td {
    text-align: left;
    vertical-align: middle;
    padding: 8px;
}


.content-area.w-100 {
    width: 100%;
    transition: width 0.3s ease-in-out;
}

.label-text,
.value-text {
    font-size: small;
}

.active2 {
    background-color: #ffefbb;
    /* Light blue background */
    font-weight: bold;
    /* Make the text bold */
}

.bg-grey {
    background: grey;
    color: white;
    padding: 10px
}

.modal-header{
   background-color: #6DB4E3;
}

.modal-title{
color:white;
}

.modal-content{
    border:none;
    margin-top:5vw;
}

.disabled{
    background-color: rgba(209, 209, 209, 0.5);
}

.form-label, .form-control, .form-select{
    font-size:small;
}


</style>